import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'highlight',
  standalone: false,
})
export class HighlightPipe implements PipeTransform {
  transform(value: string | number, searchString: string): any {
    const transformedValue = typeof value === 'number' ? value.toString() : value
    const searchRegExp = new RegExp(searchString, 'i')

    return transformedValue.replace(searchRegExp, '<mark>$&</mark>')
  }
}
